module.exports = __webpack_public_path__ + "static/media/6.0bfb3d34.jpg";